export const PRODUCTS_URL = '/products/product?code=';
export const getProductUrl = code => `${PRODUCTS_URL}${code}`;
//# sourceMappingURL=getProductUrl.js.map